import { useSelector } from '@shared/store';

/**
 * True when running in the public/external (unauthenticated) form context.
 * Use this to skip queries that only make sense for an authenticated session,
 * even though an anonymous user id is present in the store.
 */
export function useIsExternal(): boolean {
  return useSelector(state => state.appState.isExternal);
}
